<list-view *ngIf="listeCodesProjet" [liste]="listeCodesProjet"></list-view>
<floating-button [listeActions]="listeActions"></floating-button>